import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodDrink: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0c0 3.728 2.55 6.86 6 7.748V12H2v4h12v-4h-4V7.748c3.45-.888 6-4.02 6-7.748z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodDrink
